import React from "react";
import logo from "../../logo.png";
import logoDark from "../../logo-dark.png";

interface LogoProps {
    className?: string
}

export default function Logo({className}: LogoProps) {
    return (
        <picture>
            <source srcSet={logoDark} media="(prefers-color-scheme: dark)"/>
            <img src={logo} alt="App Repo" className={className} draggable={false}/>
        </picture>
    );
}
